export enum AllowRobots {
  NONE = 'None',
  ALLOW = 'Allow',
  NOINDEX = 'No index',
}
